module.exports = __webpack_public_path__ + "static/media/lavadeira-rio-identidade-visual-logotipo-768x591.28073a47.jpg";